import type { RouteRecordRaw } from 'vue-router'

/**
 * DEV-only routes, registered at runtime by `bootstrap()` in main.ts and only on
 * non-prod environments — see the comment there.
 *
 * They cannot live in `publicRoutes` below with a runtime check: this module is
 * evaluated when main.ts statically imports the router, which happens before
 * `initFirebase()` resolves the project ID, so `ENV` still holds its defaults at
 * that point. And these routes are public (`requiresAuth: false`), so on prod they
 * must not exist at all rather than merely be guarded.
 */
export const devOnlyPublicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/design-system',
    name: 'DesignSystem',
    meta: { requiresAuth: false },
    component: () => import('@/views/designSystem/DesignSystemView.vue'),
  },
]

export const publicRoutes: Array<RouteRecordRaw> = [
  // Public (general)
  {
    path: '/',
    name: 'Home',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/HomeView.vue'),
  },

  // Public (lab specific)
  {
    path: '/:labSlug',
    name: 'LabHome',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/:labSlug/reset-password',
    name: 'ResetPassword',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/ResetPasswordView.vue'),
  },
  {
    path: '/:labSlug/signup',
    name: 'LabSignUp',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/SignUpView.vue'),
  },

  // Displays — anonymous, password-gated TV/tablet screens. No labSlug in the
  // path: the viewer only ever has the displayID (from the generated link),
  // and labAccountID is always resolved server-side from the display itself.
  {
    path: '/displays/:displayID',
    name: 'PublicDisplay',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/DisplayScreenView.vue'),
  },

  // Business Central — Entra admin-consent redirect target. Plain public page, no backend
  // involvement: there is no code to exchange under the app-only connection model, so this only
  // confirms success/failure and tells the admin they can close the tab.
  {
    path: '/bc/admin-consent-complete',
    name: 'BcAdminConsentComplete',
    meta: { requiresAuth: false },
    component: () => import('@/views/BcAdminConsentCompleteView.vue'),
  },
]

